import {
  FieldBuilder,
  FieldDefinition,
  MENU_CATEGORY_KEY,
  MENU_NAME_SUFFIX,
  MENU_SUBCATEGORY_KEY,
  MenuCategories,
  MenuSubcategories,
} from '@zendra/shared';
import { PropertyService } from 'cbd-proxies';

FieldBuilder.setNamespace('Geographic');

const standNameField = FieldBuilder
  .text('name', 'Entity.GisStandInconsistency.Name')
  .readOnly()
  .build();

const areaField = FieldBuilder
  .number('standArea', 'Entity.GisStandInconsistency.Area')
  .decimal()
  .readOnly()
  .build();

const propertyField = FieldBuilder
  .foreignKey('propertyId', 'Entity.Property', PropertyService)
  .displayFromNested('property.name')
  .sortBy('property.name')
  .keyField('id')
  .readOnly()
  .build();
  
export const GISSTANDINCONSISTENCY_FIELDS: FieldDefinition[] = [
  standNameField,
  areaField,
  propertyField,
];

export const GISSTANDINCONSISTENCY_FIELDS_WITHOUT_PROPERTY: FieldDefinition[] = [
  standNameField,
  areaField,
];

export const GISSTANDINCONSISTENCY_PERMISSION = 'PlanningLocation.Stands';

export const GISSTANDINCONSISTENCY_MENU_CATEGORY =
  MENU_CATEGORY_KEY + MenuCategories.Queries + MENU_NAME_SUFFIX;

export const GISSTANDINCONSISTENCY_MENU_SUBCATEGORY =
  MENU_SUBCATEGORY_KEY + MenuSubcategories.GisInconsistencies + MENU_NAME_SUFFIX;
